import { getStatusOfInteractionOnReferral } from '@/views/Referrals/views/ReferralsList/ReferralsList.helpers';
import type { paths } from '$api-clients/generated/core';
import { useCore } from '$api-clients/hooks';
import {
  augmentAgent,
  augmentAgreementStatus,
  augmentClient,
} from './augmentReferralData';
import type { ReferralSummary } from './types';

type ReferralsParams = NonNullable<
  paths['/referrals']['get']['parameters']['query']
>;

export function useReferrals(params?: ReferralsParams) {
  const result = useCore(
    '/referrals',
    {
      params: {
        query: params,
      },
    },
    {
      keepPreviousData: true,
    },
  );

  const referrals: ReferralSummary[] =
    result.data?.results?.map((referral) => {
      const transactingAgent = augmentAgent(referral.transactingAgent);
      return {
        ...referral,
        referringAgent: augmentAgent(referral.referringAgent),
        transactingAgent,
        client: augmentClient(referral.client),
        agreementStatus: augmentAgreementStatus(referral.agreementStatus),
        transactionStatus: getStatusOfInteractionOnReferral({
          interaction: referral.latestInteraction ?? { status: null },
          transactingAgent,
        }),
      };
    }) ?? [];

  return {
    ...result,
    referrals,
    count: result.data?.count ?? 0,
  };
}
